import { render, staticRenderFns } from "./set-rule.vue?vue&type=template&id=eadd2fc6"
import script from "./set-rule.vue?vue&type=script&lang=js"
export * from "./set-rule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports